type UpsLocalStorage = {
  // authType is utilized to redirect user to correct login page when they try to access ups pages on reload
  authType?: "guest" | null;
  guestToken?: string | null;
};

const STORAGE_KEY = "ups";

function read(): UpsLocalStorage {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
}

function write(data: UpsLocalStorage) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function updateUpsLocalStorage<K extends keyof UpsLocalStorage>(
  key: K,
  value: UpsLocalStorage[K]
): void {
  const data = read();
  data[key] = value;
  write(data);
}

export function getUpsLocalStorage<K extends keyof UpsLocalStorage>(
  key: K
): UpsLocalStorage[K] | undefined {
  const data = read();
  return data[key];
}
